'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _freeSolidSvgIcons = require('@fortawesome/free-solid-svg-icons');

require('./location.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Location = function (_React$Component) {
  _inherits(Location, _React$Component);

  function Location() {
    _classCallCheck(this, Location);

    return _possibleConstructorReturn(this, (Location.__proto__ || Object.getPrototypeOf(Location)).apply(this, arguments));
  }

  _createClass(Location, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          address = _props.address,
          name = _props.name,
          beforeText = _props.beforeText,
          afterText = _props.afterText,
          showMap = _props.showMap,
          showIcon = _props.showIcon,
          inlineIcon = _props.inlineIcon;

      return _react2.default.createElement(
        'div',
        { id: 'location-container' },
        _react2.default.createElement(
          'div',
          { id: inlineIcon ? 'location-inline-desc-container' : '' },
          showIcon && _react2.default.createElement(
            'div',
            { id: inlineIcon ? 'location-inline-icon' : 'location-icon' },
            _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _freeSolidSvgIcons.faMapMarkerAlt, size: inlineIcon ? 'lg' : '2x' })
          ),
          _react2.default.createElement(
            'div',
            null,
            beforeText,
            _react2.default.createElement(
              'a',
              {
                href: 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(name + ' ' + address),
                target: '_blank',
                rel: 'noopener'
              },
              _react2.default.createElement(
                'span',
                { className: 'emphasis-text' },
                address
              )
            ),
            afterText
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          showMap && _react2.default.createElement(
            'div',
            { id: 'location-map-container' },
            _react2.default.createElement('iframe', {
              id: 'location-map-embed',
              src: 'https://maps.google.com/maps?q=' + encodeURIComponent(name + ' ' + address) + '&t=&z=13&ie=UTF8&iwloc=&output=embed',
              frameBorder: '0',
              scrolling: 'no',
              marginHeight: '0',
              marginWidth: '0'
            })
          )
        )
      );
    }
  }]);

  return Location;
}(_react2.default.Component);

exports.default = Location;


Location.propTypes = {
  address: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  beforeText: _propTypes2.default.string,
  afterText: _propTypes2.default.string,
  showMap: _propTypes2.default.bool,
  showIcon: _propTypes2.default.bool,
  inlineIcon: _propTypes2.default.bool
};

Location.defaultProps = {
  beforeText: 'We are located at ',
  afterText: '.',
  showMap: true,
  showIcon: true,
  inlineIcon: false
};